import Cookie from 'js-cookie';

import { adaptToBasketItems } from '@common/adapters/basketAdapter';

import { AddFulfilableToBasketFormValues } from '@common/features/AddedToBasket/Fulfilable/AddFulfilableToBasketForm/AddFulfilableToBasketForm.types';
import { FulfilableBasketDetails } from '@common/features/AddedToBasket/Fulfilable/FulfilableAddedToBasket.types';
import { BasketItemType } from 'shared-types/Common';
import { Property } from 'shared-types/Property';

import { BasketDetails } from 'shared-types/Basket';

type AddItemToBasketProps = {
  data: AddFulfilableToBasketFormValues;
  type: BasketItemType;
  createBasket: (
    propertyId: number | string,
    language: string,
    basketDetails: BasketDetails | FulfilableBasketDetails,
    siteSlug: string,
    timezone?: string
  ) => Promise<{ payload: BasketDetails }>;
  updateBasket: (
    propertyId: number | string,
    basketId: number | string,
    language: string,
    basketDetails: BasketDetails | FulfilableBasketDetails,
    siteSlug: string,
    timezone?: string
  ) => Promise<{ payload: BasketDetails }>;
  basketDetails: BasketDetails | FulfilableBasketDetails;
  property: Pick<Property, 'id' | 'slug' | 'timezone'>;
  language: string;
  onSuccess: (response: BasketDetails | FulfilableBasketDetails) => any;
  onError?: (error: Error) => any;
  splitMultipleQuantityItems?: boolean;
  replaceExistingItem?: { id: string | number };
};

export const addItemToBasket = ({
  data,
  createBasket,
  updateBasket,
  property,
  basketDetails,
  language,
  type,
  onSuccess,
  onError = () => {},
  replaceExistingItem,
}: AddItemToBasketProps) => {
  const adaptedItems = adaptToBasketItems(data, type);

  const basketId = Cookie.get('basketId');

  let basketAction: () => Promise<{ payload: BasketDetails }>;

  if (basketId) {
    basketAction = () =>
      updateBasket(
        property.id,
        basketId,
        language,
        {
          items: [...basketDetails.items, ...adaptedItems].filter((item) => {
            if (replaceExistingItem) {
              return item.id !== replaceExistingItem.id;
            }

            return true;
          }),
        },
        property.slug,
        property.timezone
      );
  } else {
    basketAction = () =>
      createBasket(
        property.id,
        language,
        {
          items: adaptedItems,
        },
        property.slug,
        property.timezone
      );
  }

  basketAction()
    .then((response) => onSuccess(response.payload))
    .catch((error) => onError(error));
};

export const getBasketFormName = (itemId: string) => `addToBasket-${itemId}`;
